import { CreditAddScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <CreditAddScreen />;
}
